<template>
  <div class="property-cell-container">
    <div class="property-cell-image-container">
      <img
        @click="setFavorite"
        :src="favoriteImg"
        class="favorite-heart"
        alt="blank-favorite"
      />
      <img
        v-if="displayImageURL != null"
        alt="Prop Image"
        :src="displayImageURL"
      />
      <div v-else class="empty-display-image-container">
        <img src="../../assets/Union.svg" />
        <span>No image available</span>
        <button @click="triggerEdit(1)">Upload Images</button>
      </div>
    </div>
    <div :class="property.colorOccupancy" class="property-cell-info-occupancy">
      <div>Two Week Occupancy: {{ this.property.occupancy || '0' }}%</div>
      <div>{{ this.property.percentagePrevious || '0%' }}</div>
    </div>
    <div class="property-cell-info-container">
      <h5>{{ this.property.internalName }}</h5>
      {{ this.property.zipcode.address }}
    </div>
    <div class="property-cell-buttons-container">
      <button class="property-cell-button-linked">
        <img
          class="property-cell-button-linked-img"
          alt="Door Icon"
          src="../../assets/propertyIcons/room.svg"
        />
        <div class="property-cell-button-linked-text" @click="goToLinkedRoom">
          {{ this.property.rooms.length }} Rooms linked
        </div>
      </button>
      <button class="property-cell-button-edit" @click="triggerEdit(0)">
        Edit
      </button>
      <button
        class="property-cell-button-delete"
        @click="triggerDelete(property.uuid)"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import calls from '@/api/calls'
import { auth } from '../../Firebase'

export default {
  name: 'PropertyCell',
  components: {},
  props: {
    property: Object
  },
  data() {
    return {
      displayImageURL: null
    }
  },
  computed: {
    favoriteImg() {
      if (this.property.favorite) {
        return require('@/assets/favorite.svg')
      }
      return require('@/assets/blank-favorite.svg')
    }
  },
  methods: {
    async setFavorite() {
      const isFavorite = !this.property.favorite
      const { message, data } = await calls.PUT(
        'properties/update-favorite',
        `${this.property.uuid}/${isFavorite}/${auth.currentUser.email}`
      )
      this.property.favorite = isFavorite
    },
    triggerDelete(uuid) {
      this.$emit('delete', uuid)
    },
    triggerEdit(part) {
      this.$emit('loading', true)
      this.$router.replace({
        name: 'editProperty',
        params: { id: this.property.uuid, part: part }
      })
    },
    goToLinkedRoom() {
      localStorage.setItem('currentPropertyName', this.property.internalName)
      localStorage.setItem('currentPropertyId', this.property.uuid)
      this.$router.replace({
        path: '/listings/rooms',
        query: { propertyId: this.property.uuid }
      })
    }
  },
  created() {
    const aux = this.property.images.split(',').map((e) => e.trim())
    let index = 0
    if (this.property.featureImage) index = this.property.featureImage
    this.displayImageURL = aux[index]
  }
}
</script>

<style scoped>
.property-cell-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  display: flex;
  flex-flow: column nowrap;
}

.property-cell-image-container {
  border-radius: 5px;
  height: 63%;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.property-cell-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
  border: solid 0.5px #dfdfdf;
}

.property-cell-info-container {
  font-size: 12px;
  height: 6.5%;
  padding: 8%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  border-bottom-style: solid;
  border-bottom-color: #f5f6f8;
  border-bottom-width: 2px;
}

.property-cell-info-container h5 {
  margin: 0px 0px 5px 0px;
  font-size: 12px;
  color: #000000;
}

.property-cell-buttons-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 5%;
  height: 12%;
}

.property-cell-buttons-container button {
  width: 74px;
  margin: 5px;
  text-align: center;
}

.property-cell-button-edit {
  border-radius: 4px;
  border: solid 1px var(--rentalios-dark);
  border-radius: 4px;
  background-color: #ffffff;
  color: var(--rentalios-dark);
}
.property-cell-button-edit:hover {
  background-color: rgba(102, 176, 21, 0.1);
  cursor: pointer;
}

.property-cell-button-delete {
  border-radius: 4px;
  border: solid 1px #df000f;
  border-radius: 4px;
  background-color: #ffffff;
  color: #df000f;
}

.property-cell-button-delete:hover {
  background-color: rgba(223, 0, 15, 0.1);
  cursor: pointer;
}

button.property-cell-button-linked {
  display: flex;
  flex-flow: row nowrap;
  width: 118px;
  justify-content: space-around;
  align-items: center;
  background: var(--rentalios-dark);
  border: 1px solid var(--rentalios-dark);
  box-sizing: border-box;
  border-radius: 4px;
}

button.property-cell-button-linked:hover {
  background-color: green;
  cursor: pointer;
}

.property-cell-button-linked-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #ffffff;
}

.empty-display-image-container {
  display: flex;
  width: 100%;
  height: 100%;
  flex-flow: column nowrap;
  justify-content: space-around;
  align-items: center;
  background: #f2f2f2;
}

.empty-display-image-container img {
  width: 72px;
  height: 72px;
  border: none;
  background: transparent;
}

.empty-display-image-container span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #9b9b9b;
  background: transparent;
}

.empty-display-image-container button {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #4a4a4a;
  background: transparent;
  border-radius: 4px;
  border: 1px solid #4a4a4a;
  width: 137px;
  height: 34px;
}

.empty-display-image-container:hover button {
  cursor: pointer;
}

.property-cell-info-occupancy {
  margin: 0 auto;
  margin-top: 6px;
  margin-bottom: 6px;
  display: flex;
  flex-direction: row;
  align-items: start;
  width: 90%;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(204, 0, 0, 0.1);
  color: rgba(204, 0, 0, 1);
}

.property-cell-info-occupancy > div {
  width: 90%;
  font-size: 12px;
  padding: 5px 7px 10px 7px;
}

.property-cell-info-occupancy.red {
  background: rgba(204, 0, 0, 0.1);
  color: rgba(204, 0, 0, 1);
}

.property-cell-info-occupancy.yellow {
  background: rgba(227, 151, 2, 0.1);
  color: rgba(227, 151, 2, 1);
}

.property-cell-info-occupancy.green {
  background: rgba(24, 169, 0, 0.1);
  color: rgba(24, 169, 0, 1);
}
.property-cell-image-container .favorite-heart {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 14px;
  border: none;
  background-color: white;
  padding: 4px;
  left: 14px;
  cursor: pointer;
}
@media (max-width: 768px) {
  .property-cell-info-container {
    margin: auto;
    padding: 5%;
  }
  .property-cell-info-occupancy {
    width: 100%;
  }
}
</style>
